/**
 * @file Form component to show application settings.
 * @author Tom Verschoore de la Houssaije
 */
import * as tslib_1 from "tslib";
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { AlertsService } from '../../core/alerts.service';
import { FormBase } from '../../base/form/form.base';
import { BackendSettingsService } from '../../backend-settings.service';
import { ResourceService } from '../../resource.service';
/**
 * Form component to show application settings.
 * @export
 * @class SettingsFormComponent
 * @extends {FormBase}
 */
var SettingsFormComponent = /** @class */ (function (_super) {
    tslib_1.__extends(SettingsFormComponent, _super);
    /**
     * Creates an instance of SettingsFormComponent.
     * @param {configurationsService} configurationsService
     * @param {BackendSettingsService} settingsService
     * @param {ActivatedRoute} route
     * @param {Router} router
     * @param {TranslateService} translateService
     * @param {AlertsService} alertsService
     * @memberOf SettingsFormComponent
     */
    function SettingsFormComponent(settingsService, route, router, translateService, alertsService, resourceService, backendSettings) {
        var _this = _super.call(this, settingsService, route, router, translateService, alertsService, resourceService) || this;
        _this.alertsService = alertsService;
        _this.backendSettings = backendSettings;
        return _this;
    }
    /**
     * Applies the changes, so that the user does not need to restart the application.
     * @protected
     * @param {boolean} newOrDeleted The parameter is not used.
     * @memberOf SettingsFormComponent
     */
    SettingsFormComponent.prototype.doneSaving = function (newOrDeleted) {
        var value;
        switch (this.item['Id']) {
            case 1:
                value = moment(this.item['Value']);
                if (value.isValid) {
                    this.backendSettings.publishedTill = value;
                }
                else {
                    this.alertsService.createAlert('danger', 'APP.SETTINGS.RESTART_APPLICATION');
                }
                break;
            case 2:
                value = moment(this.item['Value']);
                if (value.isValid) {
                    this.backendSettings.availabilityClosedTill = value;
                }
                else {
                    this.alertsService.createAlert('danger', 'APP.SETTINGS.RESTART_APPLICATION');
                }
                break;
            case 3:
                value = parseInt(this.item['Value']);
                if (value > 0) {
                    this.backendSettings.daysBeforeExpiration = value;
                }
                else {
                    this.alertsService.createAlert('danger', 'APP.SETTINGS.RESTART_APPLICATION');
                }
                break;
            case 4:
                value = parseInt(this.item['Value']);
                if (value > 0) {
                    this.backendSettings.daysBeforeResponse = value;
                }
                else {
                    this.alertsService.createAlert('danger', 'APP.SETTINGS.RESTART_APPLICATION');
                }
                break;
            default:
                this.alertsService.createAlert('danger', 'APP.SETTINGS.RESTART_APPLICATION');
                break;
        }
        _super.prototype.doneSaving.call(this, newOrDeleted);
    };
    return SettingsFormComponent;
}(FormBase));
export { SettingsFormComponent };
